import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Bullet } from './bullet-list-bullet';
import { IconColor } from 'visana-ui-library';

@Component({
  standalone: false,
  selector: 'ssc-bullet-list',
  templateUrl: './bullet-list.component.html',
  styleUrls: ['./bullet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulletListComponent {
  @Input() public list: Bullet[];
  @Input() public variant: 'mustard-light' | 'mustard-dark' | 'violet-light' | 'violet-mid' | 'violet-dark' =
    'mustard-light';
  @Input() public iconSize: '16' | '24';
  @Input() public backgroundSize: '40' | '32';

  public getIconColor(): IconColor {
    if (this.variant === 'mustard-light' || this.variant === 'mustard-dark') {
      return 'mustard-yellow-dark';
    } else {
      return 'violet-normal';
    }
  }

  public getIconBackgroundColor():
    | 'violet-normal'
    | 'violet-mid'
    | 'violet-light'
    | 'mustard-yellow-dark-accent'
    | 'mustard-yellow-light' {
    if (this.variant === 'mustard-dark') {
      return 'mustard-yellow-dark-accent';
    } else if (this.variant === 'mustard-light') {
      return 'mustard-yellow-light';
    } else if (this.variant === 'violet-mid') {
      return 'violet-mid';
    } else if (this.variant === 'violet-dark') {
      return 'violet-normal';
    } else {
      return 'violet-light';
    }
  }
}
